import React, { FC } from 'react';
import { Link, TableCell } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { ContentFragment } from 'api';
import { getImage } from 'features/content/helpers';
import { getAppImage, getImageSrc } from 'helpers';
import { APP_IMAGES } from 'constants/index';
import { IMAGE_HEIGHT } from 'features/activity/constants';
import { generateLink } from 'Links';

const { REACT_APP_IMGIX_HOST } = process.env;

interface IProps extends WithStyles<typeof styles> {
  content: ContentFragment;
}

const styles = (theme: Theme) =>
  createStyles({
    image: {
      height: IMAGE_HEIGHT,
      width: IMAGE_HEIGHT,
    },
    imageBorder: {
      height: IMAGE_HEIGHT,
      width: IMAGE_HEIGHT,
      border: `1px solid ${theme.custom.palette.grey3}`,
    },
    cell: {
      width: IMAGE_HEIGHT,
      paddingRight: 0,
    },
  });

const ImageCell: FC<IProps> = ({ classes, content }) => {
  const image = getImage(content);

  function getImgixUrl() {
    const key = image.file_key ? image.file_key : image.key;
    const baseUrl = `${REACT_APP_IMGIX_HOST}/${key}`;
    const params = `auto=format&fit=crop&crop=faces&w=${IMAGE_HEIGHT}&h=${IMAGE_HEIGHT}`;

    return `${baseUrl}?${params}`;
  }

  function renderPlaceholderImage() {
    let children = null;

    if (content) {
      children = (
        <Link component={generateLink(`/content/${content.content_id}`)}>
          <img className={classes.image} {...getAppImage(APP_IMAGES.SocialLoading)} />
        </Link>
      );
    } else {
      children = <img className={classes.image} {...getAppImage(APP_IMAGES.SocialLoading)} />;
    }

    return <div className={classes.imageBorder}>{children}</div>;
  }

  function renderImage() {
    if (!image || !image.bucket) {
      return renderPlaceholderImage();
    }

    const imageUrl = getImgixUrl();

    return (
      <Link component={generateLink(`/content/${content.content_id}`)}>
        <div className={classes.imageBorder}>
          <img {...getImageSrc(imageUrl)} />
        </div>
      </Link>
    );
  }

  return <TableCell classes={{ body: classes.cell }}>{renderImage()}</TableCell>;
};

export default withStyles(styles)(ImageCell);
